export default "__VITE_ASSET__DN2YgtCU__"